import loadable from '@loadable/component';

export const CreditsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "CreditsLinks" */
      './CreditsLinks.dynamic'
    ),
);
